export default (params) => ({
  trigger: {
    name: 'product_collection.confirm',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      item_id: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'drop_down_selector',
          'drop_down_panel',
          'multi_discriminant_selector',
        ],
      },
    },
    event: {
      name: 'select_item',
      params: {
        method: 'title',
      },
    },
  },
});
